import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import userStore from 'stores/user.store';
import { noAuthPaths } from 'config.json';
import Cookies from 'js-cookie';
import storage from 'libs/storage';
import layoutStore from 'stores/layout.store';

const baseGraphqlUrl = `${process.env.REACT_APP_API_URL}/graphql`;

const httpLink = createHttpLink({
  uri: baseGraphqlUrl,
  credentials: 'include'
});

const authLink = setContext(async (_, { headers }) => {
  const platform = layoutStore.getPlatform();
  if (platform === 'mobile') {
    // get the authentication token from local storage if it exists
    const token = await storage.get('token');
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : ''
      }
    };
  } else {
    const token = Cookies.get('XSRF-TOKEN');
    return {
      headers: {
        ...headers,
        'Access-Control-Allow-Credentials': true,
        'X-XSRF-TOKEN': token
      }
    };
  }
});

const logoutLink = onError(({ networkError }) => {
  if (networkError && [401, 419].includes(networkError.statusCode)) {
    if (!noAuthPaths.includes(window.location.pathname)) {
      userStore.setIsAuthenticated(false);
      apolloClient.resetStore();
    }
  }
});

const apolloClient = new ApolloClient({
  link: from([authLink, logoutLink, httpLink]),
  cache: new InMemoryCache(),
  name: 'barwis-health-mobile-app',
  queryDeduplication: false,
  defaultOptions: {
    query: {
      errorPolicy: 'all'
    },
    mutate: {
      errorPolicy: 'all'
    }
  },
  connectToDevTools: true
});

export default apolloClient;
